<div class="page has-breadcrumb has-infinite-scroll">
  <astrobin-upgrade-nudge></astrobin-upgrade-nudge>

  <ng-container *ngIf="breakpointMdMin">
    <h1 class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
      <span class="flex-grow-1 me-lg-3 mb-3 mb-md-1 mb-lg-0">
        {{ title }}
      </span>

      <span class="mb-2 me-lg-3 pt-0 pb-0">
        <ng-container *ngTemplateOutlet="regionSelectorTemplate"></ng-container>
      </span>

      <astrobin-refresh-button *ngIf="breakpointLgMin" (click)="refresh()"></astrobin-refresh-button>
    </h1>

    <small>
      <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
    </small>
  </ng-container>

  <div class="row">
    <div *ngIf="breakpointMdMin" class="col-12 col-md-5 col-lg-3">
      <ng-container *ngTemplateOutlet="sellSeekButtons"></ng-container>
      <ng-container [ngTemplateOutlet]="sidebarTemplate"></ng-container>
    </div>

    <div class="col-12 col-md-7 col-lg-9">
      <div class="d-flex flex-column mb-3">
        <astrobin-marketplace-search-bar
          (search)="refresh($event)"
          class="d-block mb-3 pt-3 pt-md-0"
        ></astrobin-marketplace-search-bar>

        <!-- Sell and Seek buttons for mobile view -->
        <div *ngIf="breakpointSmMax" class="mobile-action-buttons">
          <ng-container *ngTemplateOutlet="sellSeekButtons"></ng-container>
        </div>
      </div>

      <astrobin-marketplace-listing-cards
        #listingCards
        [listings]="listings$ | async"
      ></astrobin-marketplace-listing-cards>
    </div>
  </div>

  <!-- Removed fixed bottom buttons -->
</div>

<ng-template #sellSeekButtons>
  <div class="action-buttons">
    <a (click)="equipmentMarketplaceService.onCreateListingClicked($event)" class="btn btn-primary w-100 mb-2">
      {{ "Sell" | translate }}
    </a>

    <a (click)="equipmentMarketplaceService.onPostWantedClicked($event)" class="btn btn-secondary w-100 mb-2">
      {{ "Seek" | translate }}
    </a>
  </div>
</ng-template>

<ng-template #countryFlagTemplate>
  <fa-icon *ngIf="requestCountryCode === 'US'" icon="flag-usa"></fa-icon>
  <fa-icon *ngIf="requestCountryCode !== 'US'" icon="flag"></fa-icon>
</ng-template>

<ng-template #continentFlagTemplate>
  <fa-icon *ngIf="requestContinent === 'Americas'" icon="earth-americas"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'North America'" icon="earth-americas"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'South America'" icon="earth-americas"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'Europe'" icon="earth-europe"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'Asia'" icon="earth-asia"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'Africa'" icon="earth-africa"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'Oceania'" icon="earth-oceania"></fa-icon>
  <fa-icon *ngIf="requestContinent === 'Antarctica'" icon="globe"></fa-icon>
</ng-template>

<ng-template #regionSelectorTemplate>
  <div ngbDropdown>
    <button
      #selectRegionTooltip="ngbTooltip"
      [class.loading]="loadingService.loading$ | async"
      [ngbTooltip]="selectRegionTooltipText"
      id="region-selector"
      class="btn btn-outline-primary mb-0"
      container="body"
      ngbDropdownToggle
      placement="start"
      tooltipClass="tooltip-warning"
      triggers="manual"
    >
      <ng-container *ngIf="!!selectedRegion && selectedRegion !== WORLDWIDE">
        <fa-icon icon="flag"></fa-icon>
        {{ selectedRegionLabel }}
      </ng-container>

      <ng-container *ngIf="!selectedRegion || selectedRegion === WORLDWIDE">
        <fa-icon icon="globe"></fa-icon>
        {{ "Worldwide" | translate }}
      </ng-container>
    </button>

    <span [attr.aria-labelledby]="'region-selector'" ngbDropdownMenu>
      <button (click)="setRegion($event, WORLDWIDE)" ngbDropdownItem>
        <fa-icon icon="globe"></fa-icon>
        {{ "Worldwide" | translate }}
      </button>

      <button *ngIf="!!requestContinent" (click)="setRegion($event, requestContinent)" ngbDropdownItem>
        <ng-container *ngTemplateOutlet="continentFlagTemplate"></ng-container>
        {{ requestContinent }}
      </button>

      <button
        *ngIf="!!requestCountryCode && UtilsService.isEUCountry(requestCountryCode)"
        (click)="setRegion($event, 'EU')"
        ngbDropdownItem
      >
        <fa-icon icon="euro-sign"></fa-icon>
        {{ "European Union" | translate }}
      </button>

      <button *ngIf="!!requestCountryLabel" (click)="setRegion($event, requestCountryCode)" ngbDropdownItem>
        <ng-container *ngTemplateOutlet="countryFlagTemplate"></ng-container>
        {{ requestCountryLabel }}
      </button>

      <button (click)="startOtherCountrySelection($event)" ngbDropdownItem>
        <fa-icon icon="arrow-pointer"></fa-icon>
        {{ "Select" | translate }}
      </button>
    </span>
  </div>
</ng-template>

<ng-template #sidebarTemplate>
  <astrobin-marketplace-sidebar (filterChange)="refresh($event)"></astrobin-marketplace-sidebar>
</ng-template>

<ng-template #navTemplate>
  <ng-container [ngTemplateOutlet]="regionSelectorTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="sidebarTemplate"></ng-container>
</ng-template>

<ng-template #titleTemplate>
  {{ title }}
</ng-template>

<ng-template #descriptionTemplate>
  {{
    "AstroBin is the best place to buy and sell astrophotography equipment. You can find telescopes, cameras, mounts, filters, and much more."
      | translate
  }}
  <a class="learn-more" href="https://welcome.astrobin.com/features/marketplace" target="_blank">
    {{ "Learn more" }}.
  </a>
</ng-template>
